@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.profile.log_symptoms.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.profile.log_symptoms.generated.resources/"

@delegate:ResourceContentHash(1_037_946_279)
internal val Res.drawable.ic_severity_bad: DrawableResource by lazy {
      DrawableResource("drawable:ic_severity_bad", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_severity_bad.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(973_357_190)
internal val Res.drawable.ic_severity_good: DrawableResource by lazy {
      DrawableResource("drawable:ic_severity_good", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_severity_good.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_445_474_293)
internal val Res.drawable.ic_severity_neutral: DrawableResource by lazy {
      DrawableResource("drawable:ic_severity_neutral", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_severity_neutral.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_severity_bad", Res.drawable.ic_severity_bad)
  map.put("ic_severity_good", Res.drawable.ic_severity_good)
  map.put("ic_severity_neutral", Res.drawable.ic_severity_neutral)
}
